import { useQuery } from '@tanstack/react-query';

import { useHttpClient } from '@bonusly/http-client';
import { Recipient } from '@bonusly/recipient-entities';

import { Bonus } from '../../../types/bonus';

export const useBonus = (id: string) => {
	const http = useHttpClient('v2');

	// This package uses the parent query cache and therefore we need to prefix the query key someething unique
	// to ensure that the cache is not shared between different components. Ideally we'll get to the point where
	// we can use shared hooks to avoid this.
	return useQuery(['growth-bonus', id], async () => {
		const bonus = (
			await http.get<{ result: Bonus }>(`bonuses/${id}`, {
				params: {
					include_children: true,
				},
			})
		).data.result;

		//  I'm not a fan of this at all but the `useCommentInput` hook requires a `.recipients` property on the bonus
		//  object. Ideally this would be something handled by a Bonus{} Schema, or just a refactor of the ActionInput
		// components, but both of those are quite a lift.
		if (bonus.reason_tokens) {
			bonus.recipients = bonus.reason_tokens.map((token) => Recipient.fromReasonToken(token, bonus.receivers)).filter(Boolean) as Recipient[];
		}

		return bonus;
	});
};
